<div class="container">
    <div class="top">
        <div class="header">
            <img class="logo" mat-button height="60px" width="auto" [routerLink]="['/dashboard']" src="https://leaseforu-assets.s3.us-east-2.amazonaws.com/assets/images/logo-header.svg" alt="">
            <div>
                <button mat-button routerLink="/changePassword">Cambiar Contraseña
                    <svg style="height: 20px; width: auto;" xmlns="http://www.w3.org/2000/svg" width="31.992" height="31.992" viewBox="0 0 31.992 31.992"><defs><style>.a{fill:#3ca2d6;}</style></defs><path class="a" d="M18,2a16,16,0,1,0,16,16A16.006,16.006,0,0,0,18,2Zm0,1.391A14.6,14.6,0,1,1,3.391,18,14.594,14.594,0,0,1,18,3.391Zm0,4.868a4.164,4.164,0,0,0-4.173,4.173v2.086h-.7A2.1,2.1,0,0,0,11.041,16.6V23.56a2.1,2.1,0,0,0,2.086,2.086h9.737a2.1,2.1,0,0,0,2.086-2.086V16.6a2.1,2.1,0,0,0-2.086-2.086h-.7V12.432A4.164,4.164,0,0,0,18,8.259ZM18,9.65a2.724,2.724,0,0,1,2.782,2.782v2.086H15.214V12.432A2.724,2.724,0,0,1,18,9.65Zm-4.868,6.259H14.4a.7.7,0,0,0,.227,0h6.728a.7.7,0,0,0,.227,0h1.281a.693.693,0,0,1,.7.7V23.56a.693.693,0,0,1-.7.7H13.128a.693.693,0,0,1-.7-.7V16.6A.693.693,0,0,1,13.128,15.909ZM18,18a1.39,1.39,0,0,0-.7,2.594v.883a.7.7,0,1,0,1.391,0v-.884A1.389,1.389,0,0,0,18,18Z" transform="translate(-2 -2)"/></svg>
                </button>
                <button mat-button (click)="logout()">Cerrar Sesión
                    <svg style="height: 20px; width:auto;" xmlns="http://www.w3.org/2000/svg" width="32" height="31.992" viewBox="0 0 32 31.992"><defs><style>.a{fill:#3ca2d6;}</style></defs><path class="a" d="M18,2A16,16,0,1,0,30.9,27.449a.7.7,0,1,0-1.121-.823,14.6,14.6,0,1,1,0-17.259A.7.7,0,1,0,30.9,8.543,15.976,15.976,0,0,0,18,2Zm9.73,9.73a.7.7,0,0,0-.485,1.194L31.617,17.3H16.6a.7.7,0,1,0,0,1.391H31.617l-4.377,4.377a.7.7,0,1,0,.984.984l5.5-5.5a.7.7,0,0,0,0-1.107l-5.5-5.5A.7.7,0,0,0,27.726,11.73Z" transform="translate(-2 -2)"/></svg>
                </button>
            </div>
        </div>
        <div class="secciones">
            <div>
                <div class="title">Caratula de autorización</div>
                <span>#{{folio}}</span>
            </div>
            <div></div>
        </div>
    </div>

    <div class="body">
        <app-btn-actualizar-info style="align-self: flex-end;"></app-btn-actualizar-info>
        <div class="row">
            <div class="col-2">
                <div class="title-section"><span class="circle center">1</span></div>
            </div>
            <div class="col-2">
                <div class="title-section"><span class="circle center">2</span></div>
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <div class="input">
                    <label>Nombre del cliente</label>
                    <input [(ngModel)]="CaratulaDatos.cliente">
                </div>

                <div class="input">
                    <label>Fecha</label>
                    <input type="date" [(ngModel)]="CaratulaDatos.fecha" readonly>
                </div>

                <div class="input">
                    <label>Nombre de vendor</label>
                    <input [(ngModel)]="CaratulaDatos.vendor" readonly>
                </div>

                <div class="input">
                    <label>Nombre de ejecutivo Comercial</label>
                    <input [(ngModel)]="CaratulaDatos.comercial" readonly>
                </div>

                <div class="input">
                    <mat-slide-toggle labelPosition="before" [checked]="CaratulaDatos.rentas_anticipadas > 0">Depósito de Garantía</mat-slide-toggle>
                </div>

                <div class="input">
                    <label>Monto de depósito</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="CaratulaDatos.rentas_anticipadas">
                </div>

                <hr>

                <div class="input">
                    <mat-slide-toggle labelPosition="before" [(ngModel)]="Caratula.seguro"> Seguro</mat-slide-toggle>
                </div>

                <div class="input">
                    <label>¿Por parte de quién?</label>
                    <mat-radio-group [(ngModel)]="Caratula.por_parte_de">
                        <mat-radio-button labelPosition="before" value="LeaseForU">Lease For U</mat-radio-button>
                        <mat-radio-button labelPosition="before" value="Cliente">Cliente</mat-radio-button>
                    </mat-radio-group>
                    <!-- <mat-error *ngIf="submit && Caratula.por_parte_de">Campo obligatorio</mat-error> -->
                </div>

                <hr>

                <div class="input">
                    <label>Relación con Acreditario</label>
                    <!-- <mat-select [(ngModel)]="Caratula.relacion_acreditario">
                        <mat-option [value]="'aval'">AVAL</mat-option>
                    </mat-select> -->
                    <input [specialCharacters]="['space']" [patterns]="customPattern" mask="E{100}" [(ngModel)]="Caratula.relacion_acreditario">
                    <mat-error *ngIf="submit && !Caratula.relacion_acreditario">Campo obligatorio</mat-error>
                </div>

                <div class="input">
                    <label>Garantias</label>
                    <input [(ngModel)]="Caratula.garantias">
                </div>
            </div>

            <div class="col-2">
                <div class="input">
                    <label>Monto a arrendar</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="CaratulaDatos.monto_autorizado" readonly>
                </div>

                <div class="input">
                    <label>Tipo de Activo</label>
                    <input [(ngModel)]="CaratulaDatos.tipo_activo_arrendar" readonly>
                </div>

                <div class="input">
                    <label for="">Descripción de Activo</label>
                    <input [(ngModel)]="CaratulaDatos.descripcion_activo" readonly>
                </div>

                <div class="input">
                    <label for="">Factor o Tasa</label>
                    <input [(ngModel)]="CaratulaDatos.factor_porcentaje" readonly>
                </div>

                <div class="input">
                    <label>Plazo</label>
                    <mat-radio-group [(ngModel)]="CaratulaDatos.plazo" [disabled]="true">
                        <mat-radio-button labelPosition="before" [value]="12">12 Meses</mat-radio-button>
                        <mat-radio-button labelPosition="before" [value]="18">18 Meses</mat-radio-button>
                        <mat-radio-button labelPosition="before" [value]="24">24 Meses</mat-radio-button>
                        <mat-radio-button labelPosition="before" [value]="36">36 Meses</mat-radio-button>
                        <mat-radio-button labelPosition="before" [value]="48">48 Meses</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="input">
                    <label>Renta Inicial</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="CaratulaDatos.renta_inicial" readonly>
                </div>

                <div class="input">
                    <label>Tipo de Producto</label>
                    <input [(ngModel)]="CaratulaDatos.tipo_producto" readonly>
                </div>

                <div class="input">
                    <label>Renta Mensual</label>
                    <mat-radio-group [(ngModel)]="Caratula.renta_mensual">
                        <mat-radio-button labelPosition="before" value="Vencido">Vencido</mat-radio-button>
                        <mat-radio-button labelPosition="before" value="Anticipado">Anticipado</mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="submit && !Caratula.renta_mensual">Campo obligatorio</mat-error>
                </div>

                <div class="input">
                    <label>Monto de depósito</label>
                    <input mask="separator.2" thousandSeparator="," [(ngModel)]="CaratulaDatos.valor_residual" readonly>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-2">
                <span><strong><b>Condiciones<br>especiales</b></strong></span>
                <div class="input">
                    <label>Cobro de comisiones vendedor</label>
                    <input type="text" mask="separator.2" thousandSeparator=","  [(ngModel)]="Caratula.cobro_comision_vendor" style="margin-bottom: 15px;">
                </div>

                <div class="input">
                    <label>Pago</label>
                    <mat-radio-group [(ngModel)]="Caratula.pago">
                        <mat-radio-button labelPosition="before" value="CONTADO">Contado</mat-radio-button>
                        <mat-radio-button labelPosition="before" value="PARCIALIDADES">Parcialidades</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="input">
                    <mat-slide-toggle labelPosition="before" [(ngModel)]="Caratula.descuento_ciego">Descuento Ciego</mat-slide-toggle>
                </div>

                <div class="input">
                    <label>Monto de Descuento</label>
                    <input mask="separator.2" thousandSeparator="," [(ngModel)]="Caratula.monto_descuento">
                </div>

                <div class="input">
                    <label>Otro</label>
                    <input type="text" mask="separator.2" thousandSeparator="," [(ngModel)]="Caratula.otro">
                </div>
            </div>

            <div class="col-2">
                <span><strong><b>Comentarios</b></strong></span>
                <div class="input">
                    <label>Condición comité de crédito</label>
                    <textarea rows="6" maxlength="500" placeholder="Condición Comité de Crédito:" [(ngModel)]="CaratulaDatos.comentarios_comite" readonly></textarea>
                </div>

                <div class="input">
                    <label>Comentarios adicionales</label>
                    <textarea rows="6" maxlength="500" placeholder="Comentarios adicionales:" [(ngModel)]="Caratula.comentarios"></textarea>
                    <mat-error *ngIf="submit && !Caratula.comentarios">Campo obligatorio</mat-error>
                </div>

            </div>
        </div>
    </div>

    <button mat-icon-button (click)="GuardarCaratula()" [disabled]="pdf">
        <svg  style="height: 60px; width:auto;" xmlns="http://www.w3.org/2000/svg" width="116.322" height="116.322" viewBox="0 0 116.322 116.322"><defs><style>.a{fill:#00a5da;}.b{fill:#fff;}</style></defs><g transform="translate(-902 -3389)"><g transform="translate(739 1848)"><path class="a" d="M58.161,0A58.161,58.161,0,1,1,0,58.161,58.161,58.161,0,0,1,58.161,0Z" transform="translate(163 1541)"/></g><g transform="translate(896.596 3947.768)"><path class="b" d="M41.4-500.669q0-10.725,0-21.45a5.963,5.963,0,0,1,4.633-6.142,6.565,6.565,0,0,1,1.48-.165q10.753-.015,21.506-.009a1.767,1.767,0,0,1,1.333.539q7.188,7.155,14.4,14.284a2.217,2.217,0,0,1,.688,1.678q0,11.805,0,23.611c0,3.1.011,6.208-.006,9.312a5.921,5.921,0,0,1-4.568,5.912,7.2,7.2,0,0,1-1.645.175q-15.825.016-31.649.008a5.957,5.957,0,0,1-6.169-6.137c-.014-6.374,0-12.748,0-19.122v-2.494Zm25.685-24.262c-.148-.019-.22-.036-.292-.036q-9.671,0-19.342,0A2.322,2.322,0,0,0,45-522.431q0,21.753,0,43.507a2.643,2.643,0,0,0,.1.761,2.374,2.374,0,0,0,2.567,1.667q12.553,0,25.106,0c2.18,0,4.36.008,6.54,0a2.2,2.2,0,0,0,2.425-2.341q0-15.435-.006-30.87c0-.179-.017-.357-.028-.579h-.917c-2.586,0-5.173.011-7.759,0a5.9,5.9,0,0,1-5.841-4.915,11.06,11.06,0,0,1-.1-1.819C67.083-519.649,67.089-522.271,67.089-524.931Zm3.577,2.755.11-.152c-.006.122-.016.243-.016.365,0,1.845-.008,3.69,0,5.535a2.4,2.4,0,0,0,2.662,2.675c1.79.01,3.579,0,5.369,0,.141,0,.282-.022.6-.049Z"/><path class="b" d="M112.862-402.662a20.413,20.413,0,0,1,3.467.541,5.619,5.619,0,0,1,3.76,6.088,5.838,5.838,0,0,1-4.969,5.135,34.168,34.168,0,0,1-4.2.1,1.094,1.094,0,0,1-1.112-1.2q-.012-4.652,0-9.3a1.129,1.129,0,0,1,1.259-1.22c.591-.008,1.182,0,1.772,0Zm-.617,2.613v6.977c.7,0,1.359.009,2.02,0a3.353,3.353,0,0,0,3.414-2.793,3.427,3.427,0,0,0-2.6-4A17.845,17.845,0,0,0,112.245-400.049Z" transform="translate(-51.359 -94.439)"/><path class="b" d="M73.008-401.922a31.835,31.835,0,0,1,4.288.037,3.9,3.9,0,0,1,3.213,4.357,3.981,3.981,0,0,1-3.85,3.59c-.419.019-.839,0-1.311,0v3.741h-2.34Zm2.355,5.573c.459,0,.863.011,1.266,0a1.572,1.572,0,0,0,1.533-1.394A1.558,1.558,0,0,0,77-399.417a9.164,9.164,0,0,0-1.641-.019Z" transform="translate(-23.73 -94.95)"/><path class="b" d="M164.64-402.1v2.4h-4.906v2.322h4.444V-395h-4.466v4.724h-2.38v-1.6q0-4.348,0-8.7c0-1.141.384-1.529,1.516-1.528C160.764-402.1,162.68-402.1,164.64-402.1Z" transform="translate(-87.046 -94.862)"/></g></g></svg>
    </button>
    <button class="next-button" mat-button (click)="Save()" [disabled]="!actualizado">
        Siguiente
        <svg style="height: 20px; width:auto;"  xmlns="http://www.w3.org/2000/svg" width="31.25" height="31.25" viewBox="0 0 31.25 31.25"><defs><style>.next{fill:#00a5da;}</style></defs><path class="next" d="M15.625,0A15.625,15.625,0,1,0,31.25,15.625,15.626,15.626,0,0,0,15.625,0Zm-1.3,24.74V12.173L8.755,17.741l-2.21-2.21,9.079-9.081,9.081,9.081-2.21,2.21-5.569-5.568V24.74Z" transform="translate(31.25) rotate(90)"/></svg>
    </button>
    <app-socials-footer style="width: 100%;"></app-socials-footer>
</div>
